import { createAction, props } from '@ngrx/store';

export const rateAnswer = createAction(
    '[Rate Answer Component] Rate Answer',
    props<{ rating: boolean }>()
);

export const submitFeedback = createAction(
    '[Rate Answer Component] Submit Feedback',
    props<{ reason: string; feedback: string }>()
);